import { Navigate, Outlet } from 'react-router-dom';

import { useAuthStore } from '@/stores/auth-store';

export function SuperAdminRoute() {
  const user = useAuthStore((s) => s.user);

  if (!user?.isSuperAdmin) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
